import { ReportRow } from 'src/common/interfaces/report';
import { extractContainerIdsFromReportRows } from '../../../components/Grid/GridDataTransformer';
import { PermalinkRequestItem, PermalinkType } from '../../../http-clients/interfaces/types';

const PARTITION_SIZE = 100;

/**
 * Extracts container IDs from report rows and creates partitions for API requests
 *
 * @param rows - The report rows to extract container IDs from
 * @returns Array of partitioned request items, or null if no valid IDs found
 */
export const processContainerIds = (rows: ReportRow[] | undefined): PermalinkRequestItem[][] | null => {
    // Check if rows are valid
    if (!rows || !Array.isArray(rows)) {
        return null;
    }

    // Extract container IDs
    let containerIds: number[] = [];
    try {
        containerIds = extractContainerIdsFromReportRows(rows);
    } catch (error) {
        return null;
    }

    // Check if any container IDs were found
    if (!containerIds.length) {
        return null;
    }

    // Create partitions for API requests
    const partitions: PermalinkRequestItem[][] = [];
    for (let i = 0; i < containerIds.length; i += PARTITION_SIZE) {
        const partition = containerIds.slice(i, i + PARTITION_SIZE).map((id: number) => ({
            type: PermalinkType.CONTAINER,
            id,
        }));
        partitions.push(partition);
    }

    return partitions;
};
